export default __webpack_public_path__ + "static/joseph-b95dea77fe7e82f412adb1909174a636.jpg";